import { lobby, match, screen, toast } from '../store';
import { Campaign } from './Campaign';
import { HelpModal } from './common';
import { GwLazy, isGroundWarMode } from './GwLazy';
import { Lobby } from './Lobby';
import { Locker } from './Locker';
import { Lookbook } from './Lookbook';
import { MapGallery } from './MapGallery';
import { Match } from './Match';
import { Results } from './Results';
import { TopBar } from './TopBar';

export function App() {
  if (import.meta.env.DEV && new URLSearchParams(window.location.search).has('gallery')) return <MapGallery />;
  if (import.meta.env.DEV && new URLSearchParams(window.location.search).has('lookbook')) return <Lookbook />;
  const s = screen.value;
  const m = match.value;
  return (
    <div class="app">
      <TopBar />
      <main class="stage">
        {s === 'match' && m ? (
          isGroundWarMode(m.settings.mode) ? <GwLazy pick="GwMatchScreen" start={m} /> : <Match start={m} />
        ) : s === 'results' ? (
          m && isGroundWarMode(m.settings.mode) ? <GwLazy pick="GwResultsScreen" /> : <Results />
        ) : s === 'locker' ? (
          <Locker />
        ) : s === 'campaign' ? (
          <Campaign />
        ) : s === 'gwCampaign' ? (
          <GwLazy pick="GwCampaignScreen" />
        ) : s === 'gwArmory' ? (
          <GwLazy pick="GwArmoryScreen" />
        ) : lobby.value ? (
          <Lobby />
        ) : (
          <div class="loading">
            <div>
              <h2>Digging in…</h2>
              <p class="muted">Connecting to the lobby.</p>
            </div>
          </div>
        )}
        <HelpModal />
        {toast.value && (
          <div key={toast.value.id} class={`toast ${toast.value.kind}`} role="status">
            {toast.value.text}
          </div>
        )}
      </main>
    </div>
  );
}
